import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loader } from 'graphql.macro';
import { useMutation } from 'react-apollo-hooks';
import cn from 'classnames';

import { Button, Input, Form } from '@loyalup/ui';

import { ReactComponent as LockIcon } from 'icons/lock.svg';

import s from './Integrations.module.css';

const SETUP_SUBTOTAL_MUTATION = loader('../../../gql/mutations/SetupSubtotalIntegration.gql');

const Login = ({ finish }) => {
  const [t] = useTranslation();
  const [credentials, setCredentials] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const [loginSubtotal] = useMutation(SETUP_SUBTOTAL_MUTATION);

  const onSubmit = async () => {
    setLoading(true);
    const {
      data: { setupSubtotalIntegration: result },
    } = await loginSubtotal({ variables: credentials });
    if (result.error) {
      setError(result.error);
    } else {
      finish();
    }
    setLoading(false);
  };

  return (
    <>
      <div className={cn(s.placeholder, s.big)}>{t('Подключение Subtotal')}</div>
      <div className={s.placeholder}>
        {t(
          'Для синхронизации данных из Subtotal в Loyal UP необходимо ввести логин/пароль от свой учетной записи в Subtotal',
        )}
      </div>
      <Form className={s.form} onSubmit={onSubmit}>
        <Input
          name="subtotal-login"
          autoComplete="subtotal-login"
          value={credentials.login}
          onChange={login => setCredentials({ ...credentials, login })}
          disabled={loading}
          placeholder={t('Логин/Емейл')}
          fixedWidth={300}
          theme="toolbar-white"
          autoFocus
          required
        />
        <Input
          name="subtotal-password"
          autoComplete="new-password"
          value={credentials.password}
          onChange={password => setCredentials({ ...credentials, password })}
          placeholder={t('Пароль')}
          disabled={loading}
          type="password"
          fixedWidth={300}
          theme="toolbar-white"
          required
        />
        {error && <div className={s.formError}>{error}</div>}
        <Button type="submit" fixedWidth={200} center loading={loading}>
          {t('Подключить')}
        </Button>
        <div className={s.secure}>
          <LockIcon height={20} />
          <span>
            {t('Ваши данные в безопасности.')}
            <br />
            {t('Мы храним ваши данные в зашифрованном виде.')}
          </span>
        </div>
      </Form>
    </>
  );
};

const Finish = () => {
  const [t] = useTranslation();

  return (
    <>
      <div className={cn(s.placeholder, s.big)}>{t('Подключение с Subtotal установлено!')}</div>
      <div className={s.placeholder}>
        {t(
          'Мы уже начали первичную синхронизацию данных о ваших клиентах и записях. Эта операция может занять несколько минут. Как только она завершится мы вышлем вам уведомление по электронной почте. А пока вы можете настроить внешний вид для электронных карт.',
        )}
      </div>
      <Button className={s.submit} center element={Link} to="/designer">
        {t('Перейти в дизайнер карт')}
      </Button>
    </>
  );
};

const STEPS = {
  LOGIN: 'login',
  FINISH: 'finish',
};

const SetupSubtotal = () => {
  const [config, setConfig] = useState({ step: STEPS.LOGIN });

  if (config.step === STEPS.LOGIN) {
    return <Login finish={() => setConfig(STEPS.FINISH)} />;
  }

  return <Finish />;
};

export default SetupSubtotal;
